import { SvgIcon, SvgIconProps } from '@mui/material';

export const VerticalLine = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      viewBox="0 0 4 141"
      preserveAspectRatio="none"
      sx={{
        width: '4px',
        height: '141px',
        fill: 'none',
        ...sx,
      }}
      {...props}
    >
      <path opacity="0.3" d="M1.99998 0L1.99999 141.001" stroke="url(#paint0_linear_13033_18385)" strokeWidth="4" />
      <defs>
        <linearGradient
          id="paint0_linear_13033_18385"
          x1="-0.508684"
          y1="119.431"
          x2="-0.504906"
          y2="-980.277"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F0B90B" />
          <stop offset="1" stopColor="#999999" stopOpacity="0" />
        </linearGradient>
      </defs>
    </SvgIcon>
  );
};
